import isEmail from "validator/lib/isEmail";
import isLength from "validator/lib/isLength";
import isURL from "validator/lib/isURL";

export const requiredMessage = "От халепа! Це поле обовʼязкове";
export const invalidMessage = "От халепа! Щось тут не так";

export const validateText = (
  value: string,
  min: number,
  max = Infinity,
  required = true
) => {
  const text = value.trim();
  if (!text) return required ? requiredMessage : true;
  return isLength(text, { min, max }) ? true : invalidMessage;
};

export const validateEmail = (value: string) => {
  if (!value.trim()) return requiredMessage;
  return isEmail(value.trim()) ? true : invalidMessage;
};

export const validateLink = (value: string) => {
  if (!value.trim()) return requiredMessage;
  return isURL(value.trim(), {
    protocols: ["http", "https"],
    require_protocol: true,
  })
    ? true
    : invalidMessage;
};
